module.exports = __webpack_public_path__ + "media/theme/icon__footer--menu-91c1983c.svg";